import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=4c2e4a54&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"
import style0 from "./JobList.vue?vue&type=style&index=0&id=4c2e4a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e4a54",
  null
  
)

export default component.exports